export const createCategory = (code, name, type) => {
  return `mutation {
        createCategory(code:"${code}", name:"${name}", type:"${type}") {
            id
            code
            name
        }
    }`
}
